import { Reducer } from "../../../lib/redux";
import { InspectionActions } from "./actions";
import { InspectionActionTypes, IInspectionStore } from "./types";

export const defaultInspection: IInspectionStore = {
    availableAssetTypes: [],
    regulatoryAssetTypeIds: [],
    selectedAsset: null,
    selectedHistoryAsset: null,
    inspectionTypes: [],
    inspectionTypesLoaded: false
};

export const inspection: Reducer<IInspectionStore, InspectionActions> = (
    state = defaultInspection,
    action
): IInspectionStore => {
    switch (action.type) {
        case InspectionActionTypes.SET_AVAILABLE_ASSET_TYPES:
            return {
                ...state,
                availableAssetTypes: action.payload
            };

        case InspectionActionTypes.SET_REGULATORY_ASSET_TYPE_IDS:
            return {
                ...state,
                regulatoryAssetTypeIds: action.payload
            };

        case InspectionActionTypes.SET_SELECTED_ASSET:
            return {
                ...state,
                selectedAsset: action.payload
            };

        case InspectionActionTypes.SET_SELECTED_HISTORY_ASSET:
            return {
                ...state,
                selectedHistoryAsset: action.payload
            };

        case InspectionActionTypes.SET_ACTIVE_INSPECTION:
            return {
                ...state,
                selectedAsset: state.selectedAsset
                    ? { ...state.selectedAsset, activeInspection: action.payload }
                    : null
            };

        case InspectionActionTypes.SET_PENDING_TRAILER_FOR_SUBMITTED:
            return {
                ...state,
                pendingTrailerForSubmitted: action.payload
            };

        case InspectionActionTypes.CLEAR_INSPECTION_STATE:
            // availableAssetTypes (loaded on inspections/main mount) and regulatoryAssetTypeIds (loaded by
            // useRegulatoryAssetTypeIds) are per-database and survive the reset: pages reached without remounting
            // main, e.g. inspectionSubmitted, read the asset types from the slice. inspectionTypes resets so
            // reviewAndCertify, which loads them only when !inspectionTypesLoaded, picks up admin changes.
            return {
                ...defaultInspection,
                availableAssetTypes: state.availableAssetTypes,
                regulatoryAssetTypeIds: state.regulatoryAssetTypeIds
            };

        case InspectionActionTypes.FETCH_INSPECTION_TYPES_REQUEST:
            return state;

        case InspectionActionTypes.FETCH_INSPECTION_TYPES_SUCCESS:
            return {
                ...state,
                inspectionTypes: action.payload,
                inspectionTypesLoaded: true
            };

        default:
            return state;
    }
};
